module.exports = __webpack_public_path__ + "static/media/NewMessageNotification.2a68d4b6.wav";